export function fullscreenOn() {
  var fullscreenElement = document.fullscreenElement ||
                         document.mozFullScreenElement ||
                         document.webkitFullscreenElement ||
                         document.msFullscreenElement;
  return (fullscreenElement != null);
}

export function turnOnFullscreen() {
  var i = document.body;
  if (i.requestFullscreen) {
    i.requestFullscreen();
  } else if (i.webkitRequestFullscreen) {
    i.webkitRequestFullscreen();
  } else if (i.mozRequestFullScreen) {
    i.mozRequestFullScreen();
  } else if (i.msRequestFullscreen) {
    i.msRequestFullscreen();
  }
}

export function turnOffFullscreen() {
  if(document.exitFullscreen) {
    document.exitFullscreen();
  } else if(document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if(document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
}